import { REQUESTED_PARTS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/requested_parts_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'requestedPartsIndex',
	'stockLocationShipmentsIndex',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
